import React, {useState} from "react"
import {Button, FormLabel, Modal} from "react-bootstrap"
import {delFile, delFolder, postFolder, putFile, putFolder} from "../../lib/api";
import {EditableText, EditableTextArea} from "../Shared/EditableWidgets";

function FileEdit(props: {
  file: any,
  parentFolderId: string | null,
  loadData: any,
  show: boolean;
  onHide: () => void;
}) {
  const {file, parentFolderId, loadData, show, onHide} = props;
  const [error, setError] = useState(null);
  const [enabled, setEnabled] = useState(true);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('Add Bookmark');

  function showModal() {
    setTitle(file.id ? `Edit ${file.fileType === "folder" ? "Folder" : "File"}` : 'Add Folder');
    setName(file.name);
    setDescription(file.description);
    setError(null);
  }

  function deleteFile() {
    setError(null);
    setEnabled(false);
    const message = `Are you sure you want to delete ${file.fileType}?`;

    const answer = window.confirm(message)
    if (!answer) {
      setEnabled(true);
      return;
    }

    if (file.fileType === "folder") {
      delFolder(file.id)
        .then(responseHandler);
    } else {
      delFile(file.id)
        .then(responseHandler);
    }
  }

  function saveFile() {
    setError(null);
    setEnabled(false);

    if (file.id) {
      if (file.fileType === "folder") {
        putFolder(file.id, {name})
          .then(responseHandler);
      } else {
        putFile(file.id, {name, description})
          .then(responseHandler);
      }
    } else {
      postFolder({name, folderId: parentFolderId})
        .then(responseHandler);
    }

  }

  function responseHandler(response: any) {
    setEnabled(true);
    if (response.ok) {
      onHide()
      loadData()
    } else {
      // @ts-ignore
      response.json().then(json => {
        setError(json?.error);
      });
    }
  }

  return (
    <Modal show={show}
           className="member-edit"
           animation={false}
           onShow={showModal}
           onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <FormLabel className="mb-1 h-auto">Name</FormLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <EditableText
              value={name}
              maxLength={60}
              onChange={(event: any) => setName(event.target.value)}
              isEditable={true}
              isEditing={enabled}
              setIsEditing={() => {
              }}
              placeholder="Name"
              ariaLabel="Name"
            />
          </div>
        </div>
        {file.fileType == "file" ?
          (<>
            <div className="row">
              <div className="col-12 pt-2">
                <FormLabel className="mb-1 h-auto">Description</FormLabel>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <EditableTextArea
                  value={description}
                  maxLength={2048}
                  rows={6}
                  onChange={(event: any) => setDescription(event.target.value)}
                  isEditable={true}
                  isEditing={true}
                  setIsEditing={() => {
                  }}
                  placeholder="Description you would like to see when you show the context menu in VR"
                  ariaLabel="Description"
                />
              </div>
            </div>
          </>)
          : null
        }
        {error ?
          (
            <div className="row error">
              <div className="col-12">
                {(error as any)?.message}
              </div>
            </div>
          )
          : null
        }
      </Modal.Body>
      <Modal.Footer>
        <div className="row px-0">
          <div className="col text-right">
            {file.id ?
              <Button
                variant="secondary"
                className="mx-4"
                onClick={deleteFile}
                disabled={!enabled}>Delete</Button>
              : null
            }
            <Button
              variant="secondary"
              className="ml-2"
              onClick={onHide}
              disabled={!enabled}
            >
              Cancel
            </Button>
            <Button
              onClick={saveFile}
              style={{marginLeft: "10px"}}
              variant="primary"
              disabled={!enabled}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default FileEdit;
